import BaseTrackingView from '../../core/baseTrackingView';
import * as commonTrackingHelper from '../../tracking/common/helper';
import * as registry from '../../../home24/core/registry';
import $ from 'jquery';

export default BaseTrackingView.extend({
  events: {
    'change #trusted-shops': 'onTrustedShopsChange',
    'change [name="payment[method]"]': 'onUserPaymentMethodChange'
  },

  onTrustedShopsChange: function(event) {
    var oTrackingData = registry.get('trustedShopTrackingData');

    if (oTrackingData && typeof window.dataLayer !== 'undefined') {
      if ($(event.currentTarget).is(':checked')) {
        window.dataLayer.push(
          commonTrackingHelper.prepareCartAddObject(oTrackingData, 1)
        );
      } else {
        window.dataLayer.push(
          commonTrackingHelper.prepareCartRemoveObject(oTrackingData, 1)
        );
      }
    }
  },

  onUserPaymentMethodChange: function() {
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'checkoutOption',
        ecommerce: {
          checkout_option: {
            actionField: {
              step: 3,
              option: this.$('[name="payment[method]"]')
                .filter(':checked')
                .val()
            }
          }
        }
      });
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/checkout/Payment.js
 **/